// Do NOT add "use client" to this file
import { PLACEHOLDER_IMAGE } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/consts";
// If there is no best image, return a placeholder image
// The fallback logic is copied from brand product tile, where we fall back to
// const PLACEHOLDER_IMAGE = IImage.build({
//   token: "p_placeholder",
//   url: "https://cdn.faire.com/fastly/3f21a8e5b96b2c091abc81901eddfd258b8a5db4f3abcf99ecefb5dbde7d54b6.png",
// });
export var getImage = function(productTile) {
    return (productTile === null || productTile === void 0 ? void 0 : productTile.best_image) ? productTile.best_image : PLACEHOLDER_IMAGE;
};
